import React from "react";

export function DonatePage() {
  return (
    <main className="min-h-screen bg-white text-gray-900 flex flex-col items-center justify-center">
      <h1 className="text-4xl font-bold mb-4">Support The Blk Bloc</h1>
      <p className="max-w-md text-center text-gray-600 mb-8">
        Your donation helps fund demolition, container builds, and community programs in Detroit and beyond.
      </p>
      <a
        href="https://givebutter.com/blkbloc" // replace with your link
        className="bg-amber-500 hover:bg-amber-400 text-gray-900 px-6 py-3 rounded-xl font-semibold"
      >
        Donate Now
      </a>
    </main>
  );
}
